module.exports = __webpack_public_path__ + "static/media/03.122b0c2a.wav";